// ==============================|| DRAWER - SIDEBAR DESIGN TOKENS ||============================== //
//
// Single source of truth for the sidebar surface. Previously the background colour was
// hard-coded as '#0f1117' in five separate files, which made the sidebar impossible to
// retheme and drifted out of sync with the rest of the design language.
//
// Contrast notes (measured against SIDEBAR.bg):
//   text         10.3:1  — well above the WCAG AA 4.5:1 requirement for body text
//   sectionLabel  5.8:1  — was 2.4:1 previously, which failed AA
//   icon          6.9:1
//   accent        7.9:1
//
// The accent is the theme's info.light (#7EB9FF). The theme's primary.main is near-black,
// so it cannot serve as an accent on a dark surface; info.light is the closest existing
// theme colour and keeps the sidebar tied to the application palette.

const SIDEBAR = {
  // surfaces — lifted off pure black to a slate that reads as deliberate rather than dim
  bg: '#3C3C3C',
  bgElevated: '#252525',
  border: 'rgba(255,255,255,0.09)',

  // foreground
  text: 'rgba(255,255,255,0.78)',
  textActive: '#FFFFFF',
  icon: 'rgba(255,255,255,0.62)',
  sectionLabel: 'rgba(255,255,255,0.55)',

  // accent + states
  accent: '#7EB9FF',
  activeBg: 'rgba(126,185,255,0.14)',
  activeBgHover: 'rgba(126,185,255,0.20)',
  hoverBg: 'rgba(255,255,255,0.07)',
  focusRing: 'rgba(126,185,255,0.55)',

  // chrome
  divider: 'rgba(255,255,255,0.07)',
  scrollThumb: 'rgba(255,255,255,0.20)',
  shadow: '2px 0 16px rgba(0,0,0,0.28)'
};

export default SIDEBAR;
